import React from 'react';
import { Row, Col } from 'antd';

import * as S from './styles';

export function Texto({ titulo, valor, color = '' }) {
  return <Col justify="space-between">
    <Row>
      <S.TextoDetalheMotorista title>{titulo || ''}</S.TextoDetalheMotorista>
    </Row>
    <Row>
      <S.TextoDetalheMotorista color={color}>
        {valor || ''}
      </S.TextoDetalheMotorista>
    </Row>
         </Col>;
}
